import { useEffect, useState } from "react"

import { Flex, Typography } from "antd"
import { useDispatch, useSelector } from "react-redux"

import ButtonComponent from "../../../../Components/Button"
import { useExternalDemoMode } from "../../../../hooks/useExternalDemoMode"
import { buildPublicApiDocsUrl } from "../../../../Utils/utils"
import PublicApiCreators from "../reducer"
import ApiKeyField from "./ApiKeyField"

import "./publicapi.less"

const { Title, Text, Link, Paragraph } = Typography

const PublicApiPage = () => {
  const [internalKeyHidden, setInternalKeyHidden] = useState(true)
  const [zapierKeyHidden, setZapierKeyHidden] = useState(true)
  const { apiKeys } = useSelector((state) => state.publicApi)
  const { is_demo } = useSelector((state) => state.auth.userInfo)
  const businessAccount = useSelector((state) => state.user.businessAccount)
  const isOnboardingIncomplete = businessAccount?.status === "incomplete"
  const externalDemoMode = useExternalDemoMode()
  const apiKeysResults = apiKeys?.results || []

  const zapierKey = apiKeysResults?.find((key) =>
    ["zapier", "external"].includes(key.platform)
  )?.key
  const internalKey = apiKeysResults?.find((key) => key.platform === "internal")?.key

  const dispatch = useDispatch()
  useEffect(() => {
    if (externalDemoMode) return
    dispatch(PublicApiCreators.getApiKeysRequest())
  }, [externalDemoMode])

  const generateZapierKey = () => {
    dispatch(PublicApiCreators.generateApiKeyRequest({ platform: "zapier" }))
    setZapierKeyHidden(true)
  }

  const generateInternalKey = () => {
    setInternalKeyHidden(true)
    dispatch(PublicApiCreators.generateApiKeyRequest({ platform: "internal" }))
  }

  const regenerateZapierKey = () => {
    setZapierKeyHidden(true)
    dispatch(PublicApiCreators.regenerateApiKeyRequest({ platform: "zapier" }))
  }

  const regenerateInternalKey = () => {
    setInternalKeyHidden(true)
    dispatch(PublicApiCreators.regenerateApiKeyRequest({ platform: "internal" }))
  }

  return (
    <div className="public-api-page">
      <div className="header" style={{ marginBottom: 23 }}>
        <Title level={4}>Public API</Title>
        <Text type="secondary" style={{ fontWeight: 500 }}>
          API keys allow you to accesss your own data via the API.
          <a href={buildPublicApiDocsUrl()} target="_blank" rel="noreferrer">
            <Link> See API documentation.</Link>
          </a>
        </Text>
      </div>
      <Flex gap={61} vertical>
        <Flex gap={32} wrap className="key-row">
          <div className="key-description-block">
            <Paragraph className="key-description-title">Internal key</Paragraph>
            <Paragraph className="key-description-text" type="secondary">
              Internal API key reserved for backend processes, allowing different parts of the
              Chargeback.io platform to share data and stay synchronized.
            </Paragraph>
          </div>
          {internalKey ? (
            <Flex className="api-key-container" vertical gap={16} align="start">
              <ApiKeyField
                className="api-key"
                value={internalKey}
                hidden={internalKeyHidden}
                setHidden={setInternalKeyHidden}
              />
              <ButtonComponent
                size="large"
                text="Regenerate API key"
                disabled={is_demo || isOnboardingIncomplete || externalDemoMode}
                onClick={regenerateInternalKey}
              />
            </Flex>
          ) : (
            <ButtonComponent
              size="large"
              text="Generate API key"
              type="primary"
              disabled={is_demo || isOnboardingIncomplete || externalDemoMode}
              onClick={generateInternalKey}
            />
          )}
        </Flex>
        {/* <Flex gap={32}>
          <div className="key-description-block">
            <Paragraph className="key-description-title">Zapier key</Paragraph>
            <Paragraph className="key-description-text" type="secondary">
              Zapier API key is required for external integrations through
              Zapier. It should only be used for connecting your account to
              Zapier and must be kept secure.
            </Paragraph>
          </div>
          {zapierKey ? (
            <Flex className="api-key-container" vertical gap={16} align="start">
              <ApiKeyField
                className="api-key"
                value={zapierKey}
                hidden={zapierKeyHidden}
                setHidden={setZapierKeyHidden}
              />
              <ButtonComponent
                size="large"
                text="Regenerate API key"
                onClick={regenerateZapierKey}
              />
            </Flex>
          ) : (
            <ButtonComponent
              type="primary"
              size="large"
              text="Generate API key"
              onClick={generateZapierKey}
            />
          )}
        </Flex> */}
      </Flex>
    </div>
  )
}

export default PublicApiPage
